import { render, staticRenderFns } from "./socialCreateUser.vue?vue&type=template&id=10c751b6"
import script from "./socialCreateUser.vue?vue&type=script&lang=js"
export * from "./socialCreateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports